<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items v-if="isUser" :items="navMenuItems" />
    <vertical-nav-menu-items
        v-if="isCreator"
        :items="navMenuItemsCr"
        class="navigation navigation-main "
    />
  </div>
</template>

<script>
import navMenuItems from '@/navigation/horizontal'
import navMenuItemsCr from '@/navigation/horizontalCr'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'
import Vue from "vue";

export default {
  components: {
    HorizontalNavMenuItems,
  },
  setup() {
    return {
      navMenuItems,
      navMenuItemsCr,
      isCreator: Vue.prototype.$isCreator,
      isAdmin: Vue.prototype.$isAdmin,
      isUser: Vue.prototype.$isUser,
    }
  },
  methods: {
    changeMenu(value) {
      this.isCreator = value
    },
    changeMenu2(value) {
      this.isUser = value
    },
  },
  mounted() {
    this.$root.$on('component1', value => {
      this.changeMenu(value)
    })
    this.$root.$on('component2', value => {
      this.changeMenu2(value)
    })
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
